import React from "react";
import { Box, Icon, Popover } from "@amzn/awsui-components-react";
import { Investigation } from "../../lusca-search-api/generated-src";
import { formatTimestamp } from "./investigationUtils";

interface InvestigationStaleBadgeProps {
  investigation: Investigation;
}

/** Whole days since the last human activity, or undefined when unknown. */
const idleDays = (at?: string | null): number | undefined => {
  const ms = at ? Date.parse(at) : NaN;
  return Number.isNaN(ms)
    ? undefined
    : Math.max(0, Math.floor((Date.now() - ms) / 86_400_000));
};

/**
 * Quiet marker for an active case with no human activity for the configured stale period:
 * muted inline text rather than a coloured pill, so it doesn't compete with the status chip.
 */
export const InvestigationStaleBadge: React.FC<
  InvestigationStaleBadgeProps
> = ({ investigation }) => {
  if (!investigation.isStale) return null;
  const days = idleDays(investigation.lastHumanActivityAt);
  return (
    <Popover
      dismissButton={false}
      position="top"
      size="small"
      triggerType="custom"
      content={`No activity since ${formatTimestamp(
        investigation.lastHumanActivityAt
      )}.`}
    >
      <span style={{ whiteSpace: "nowrap", cursor: "default" }}>
        <Box variant="small" color="text-status-inactive" display="inline">
          <Icon name="status-pending" size="small" variant="subtle" />{" "}
          {days !== undefined ? `Stale · ${days}d` : "Stale"}
        </Box>
      </span>
    </Popover>
  );
};

export default InvestigationStaleBadge;
